import { render, staticRenderFns } from "./inedx.vue?vue&type=template&id=4aeb7bc9&scoped=true&"
import script from "./inedx.vue?vue&type=script&lang=ts&"
export * from "./inedx.vue?vue&type=script&lang=ts&"
import style0 from "./inedx.vue?vue&type=style&index=0&id=4aeb7bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb7bc9",
  null
  
)

export default component.exports